module.exports = __webpack_public_path__ + "img/KMD-alt.6587ae0a.svg";